export class CreateAccountCommand {
    constructor(public userName: string,
                public password: string) {
    }
}

export class CreateAccountUserCommand {
    constructor(public hubName: string,
                public userName: string,
                public password: string) {
    }
}

export class EventCountCommand {
    public approved: number;
    public unapproved: number;
    public fbPage: any;
    public eventbritePage: any;
    public eventful: any;
    public serpGoogle: any;
    public aiAggregator: any;
    public deliveryStatistics: any;
    public lastRunTime: any;
    public spiderMonthlyCount: any;
}

export interface EventSubscriptionTier {
    _id?: string;
    name: string;
    annualEventLimit: number;
    isActive: boolean;
}

export interface EventContractSettings {
    accountId: string;
    subscriptionTierId: string;
    contractStartDate: string | Date;
    tier: EventSubscriptionTier;
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/commands/accounts/create.account.command.ts